<template>
  <div>
    <b-modal ref="myModalRef" :ok-only="true" title="Detalhes do Cupom" size="lg" :hide-header="true" @hidden="hide">
      <div class="coupon_code_section" v-if="coupon">
        <div class="coupon_logo">
          <img v-if="store" :src="store.image" alt="Carregando...">
          <img v-else :src="coupon.image" alt="Carregando...">
        </div><!-- coupon_logo End -->
        <div class="coupon_description">
          <h2>{{ coupon.description }}</h2>
        </div><!-- coupon_description End -->
        <div class="coupon_form" v-if="coupon.trackingLink">
          <p v-if="this.$route.params.slug"><span>Você estará ajudando o projeto selecionado:</span></p>
          <p v-else><span>Selecione um projeto abaixo para ajudar</span></p>
          <b-form-select v-model="ProjectSlug" class="mb-3" @input="onChangeProject" v-if="this.$route.params.slug" disabled>
            <option v-for="(p, i) in projects" :key="i" :value="p.slug">{{p.Info.title}}</option>
          </b-form-select>
          <b-form-select v-model="ProjectSlug" class="mb-3" @input="onChangeProject" v-else>
            <option :value="null">Selecione um projeto...</option>
            <option :value="'all'">Ajudar todos os Projetos</option>
            <option v-for="(p, i) in projects" :key="i" :value="p.slug">{{p.Info.title}}</option>
          </b-form-select>
          <div class="clearfix add_coupon_code" v-if="ProjectSlug && !loading">
            <a v-if="coupon.trackingLink" class="button tracking" target="_blank" :href="url">
              Acessar Desconto!
            </a>
          </div>
          <div class="clearfix add_coupon_code loading" v-if="loading">
            Aguarde, carregando seu link...
          </div>
          <h6 v-if="ProjectSlug && coupon.trackingLink">Clique no botão acima para ativar o seu desconto.<br/>Ao efetuar a compra, o projeto selecionado será beneficiado.</h6>
        </div>
        <div class="coupon_form" v-else>
          <p><span>Ajude todos os projetos da Click2Giv</span></p>
          <div class="clearfix add_coupon_code">
            <input type="text" style="position: absolute; z-index: -9; left:0;" :value="coupon.code">
              <input class="form-control unselectable" type="text" id="abcd" name="" :value="coupon.code" readonly @click="copyToClipboard()">
              <a class="button" target="_blank" @click="copyToClipboard()">
                Copiar
              </a>
          </div>
          <h6 v-if="coupon.trackingLink">Clique no código ou em "Acessar" para copiar o cupom.<br/>Adicione o código no carrinho de compras no site da loja se necessário.</h6>
          <h6 v-else>Copie o cupom, e adicione o código no carrinho de compras no site da loja.</h6>
        </div>
      </div>
      <div class="coupon_footer" v-if="coupon">
        <div class="social_link_view">
          <!-- <ul>
            <li>
              <a :href="'mailto:?subject=DescontosDoBem&body=https://click2giv.com/descontosdobem/' + coupon.slug" class="at">
                <font-awesome-icon :icon="['fas', 'at']" size="lg" />
              </a>
              </li>
            <li><a :href="'https://twitter.com/share?text=DescontosDoBem&url=http://https://click2giv.com/descontosdobem/' + coupon.slug" target="_blank" class="twi"><font-awesome-icon :icon="['fab', 'twitter']" size="lg" /></a></li>
            <li><a :href="'https://facebook.com/sharer/sharer.php?u=https://click2giv.com/descontosdobem/' + coupon.slug" target="_blank" class="face"><font-awesome-icon :icon="['fab', 'facebook']" size="lg" /></a></li>
            <li><a :href="'whatsapp://send?text=https://click2giv.com/descontosdobem/' + coupon.slug + ' DescontosDoBem'" target="_blank" class="whats"><font-awesome-icon :icon="['fab', 'whatsapp']" size="lg" /></a></li>
          </ul> -->
          <ul>
            <li>
              <a :href="'mailto:?subject=DescontosDoBem&body=' + coupon.trackingLink" class="at">
                <font-awesome-icon :icon="['fas', 'at']" size="lg" />
              </a>
              </li>
            <li><a :href="'https://twitter.com/share?text=DescontosDoBem&url=' + coupon.trackingLink" target="_blank" class="twi"><font-awesome-icon :icon="['fab', 'twitter']" size="lg" /></a></li>
            <li><a :href="'https://facebook.com/sharer/sharer.php?u=' + coupon.trackingLink" target="_blank" class="face"><font-awesome-icon :icon="['fab', 'facebook']" size="lg" /></a></li>
            <li><a :href="'whatsapp://send?text=' + coupon.trackingLink" target="_blank" class="whats"><font-awesome-icon :icon="['fab', 'whatsapp']" size="lg" /></a></li>
          </ul>
        </div>
        <h5>Compartilhe e ajude ainda mais</h5>
      </div>
    </b-modal>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faFacebookF, faTwitter, faWhatsapp} from '@fortawesome/fontawesome-free-brands'
import {faAt} from '@fortawesome/fontawesome-free-solid'
import auth from '../../services/auth'
import { API } from '../../services/api'

export default {
  props: ['show', 'coupon', 'store'],
  name: 'CouponModal',
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      user: null,
      projects: null,
      ProjectSlug: null,
      UserId: null,
      TrackingId: null,
      url: null,
      type: null,
      loading: false,
      showModal: this.show,
    }
  },
  created(){
    if(auth.isAuth()){
      this.getProfile()
    }
    this.loadProjects();
  },
  methods: {
    getProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((result) => {
        this.UserId = result.body.user.UserId;
      });
    },
    loadProjects(){
      this.$http.get(API.Projects.projects).then((result) => {
        this.projects = result.body;
        if(this.$route.params.slug && this.coupon){
          this.ProjectSlug = this.$route.params.slug;
        }
      });
    },
    generateTrackingToken(){
      // if(this.ProjectSlug || this.UserId){
        var project = this.projects.filter(p => {
          return p.slug == this.ProjectSlug;
        })
        if(project && project[0]){
          this.$http.post(API.Coupons.registerSharedLink, {
            ProjectId: project[0].ProjectId,
            UserId: this.UserId,
            url: this.coupon.trackingLink,
            type: this.coupon.couponType,
            registerType: 'tracking'
          }).then((res) => {
            this.loading = false;
            if(res.body.success){
              this.TrackingId = res.body.TrackingId
              this.url = res.body.url
            }else{
              console.log("ERRO AO GERAR TRACKING")
            }
          });
        }
      // }
    },
    onChangeProject(ProjectSlug){
      this.loading = true;
      this.ProjectSlug = ProjectSlug;
      this.generateTrackingToken();
    },
    open(){
      this.loading = true;
      if(this.projects){
        if(this.$route.params.slug){
          this.ProjectSlug = this.$route.params.slug;
          this.generateTrackingToken();
        }
      }
      this.$refs.myModalRef.show()
    },
    hide(bvEvt){
      this.ProjectSlug = null;
      this.TrackingId = null;
    },
    copyToClipboard(){
      var copyText = document.getElementById("abcd");
      copyText.select();
      document.execCommand("copy");
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon_logo {
    text-align: center;
    position: relative;
}
.coupon_description {
    text-align: center;
    padding: 0 30px;
    word-break: break-word;
    margin-top: 20px;

    h2{
      font-size: 25px;
    }
}
.coupon_form{
  width: 100%;
  margin: 0 auto;

  p{
    padding-top: 20px;
    margin-bottom: 0;
    padding-bottom: 30px;
    font-size: 16px;
    text-align: center;
  }

  h6{
    text-align: center;
    font-size: 16px;
    padding-top: 20px;

    a{
      color: #0B8043;
      display: block;
      text-decoration: none;
    }
  }

  .add_coupon_code{
    position: relative;
    border: 1px solid #D9D9D9;
    padding: 8px;
    margin-bottom: 0;

    &.loading{
      text-align: center;
      font-weight: bold;
    }

    .unselectable{
      float: left;
      cursor: pointer;
    }

    input{
      // pointer-events: none;
      border: 0;
      height: 45px;
      width: 64%;
      font-size: 27px;
    }
    button, .button{
      cursor: pointer;
      text-decoration: none;
      width: 36%;
      height: 45px;
      float: right;
      font-size: 24px;
      text-align: center;
      color: #fff;
      line-height: 40px;
      background-color: #0FAE39;
      border: 1px solid #00AE39;

      &.tracking{
        width: 100%;
      }
    }
  }
}

.coupon_footer{
  text-align: center;
  padding-bottom: 20px;

  h5{
    font-size: 19px;
    color: #555;
    padding-top: 10px;
  }

  .social_link_view{
    float: none;
    margin-top: 20px;

    ul{
      list-style: none;
      padding: 0;

      li{
        padding: 10px;
        display: inline-table;

        a{
          display: block;
          width: 50px;
          height: 50px;

          &.at{
            background-color: #aaa;
          }

          &.twi{
            background-color: #1DA1F2;
          }

          &.face{
            background-color: #3B5998;
          }

          &.whats{
            background-color: #25d366;
          }

          svg{
            color: #fff;
            margin-top: 15px;
          }

        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/descontosdobem/CouponModal.vue